import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Form, ButtonGroup, Button } from 'reactstrap';
import './widgets.css';
import { t } from 'i18next';
import { getDataUserByKey, getTenantInfoByKey, getUserBuilding, getUserOpening } from '../../helpers/helpers';
import { CustomAlert } from '../CustomAlert/CustomAlert';
import { DonutChart } from '../Charts/DonutChart/DonutChart';
import { useNavigate } from 'react-router-dom';
import EntryAndDepartureReportContext from '../../context/EntryAndDepartureReportContext/EntryAndDepartureReportContext';
import { AREAS, BUILDINGS, OPENINGS, checkResTypesSelected, getLevelsToWidgetByResources, goBackOneLevel, resTypesInitial, widgetNameByUserAndInfo } from './dashboardHelpers';
import WidgetResourcesInPlaceContext from '../../context/WidgetResourcesInPlace/WidgetResourcesInPlaceContext';
import AccessOpeningContext from '../../context/AccessOpeningContext/AccessOpeningContext';
import AccessBuildingContext from '../../context/AccessBuildingContext/AccessBuildingContext';
import AccessAreaContext from '../../context/AccessAreaContext/AccessAreaContext';

const NumberOfResourcesByPlace = () => {
    const navigate = useNavigate();

    const { widgetResourcesInPlaceState, getResourcesInPlaceByOpennings, getResourcesInPlaceByBuildings, getResourcesInPlaceByAreas, setLevelInTheWidget, setCodesInTheResourcesInPlace } = useContext(WidgetResourcesInPlaceContext);
    const { error, resources, isFetching, codesTofilter, levelSelected, entitySelected } = widgetResourcesInPlaceState;
    const { openingCodeSelectedInWidget, buildingCodeSelectedInWidget, resourcesTypesSelectedInWidget } = codesTofilter;
    const { openingSelectedInTheWidget, buildingSelectedInTheWidget } = entitySelected;

    const keyType = Object.keys(resTypesInitial);

    const { entryAndDepartureReportState, setFilters } = useContext(EntryAndDepartureReportContext);
    const { filters } = entryAndDepartureReportState;

    const { getAccessOpenings } = useContext(AccessOpeningContext);

    const { getAccessBuildings } = useContext(AccessBuildingContext);

    const { getAccessAreas } = useContext(AccessAreaContext);


    const filtersInitial = {
        date_from: '',
        date_to: '',
        resource_type: [],
        contractors: [],
        search_text: '',
        opening_code: [],
        user_created: [],
        areas: [],
        permanence_time_from: 0,
        permanence_time_to: null,
        column_order: 'name',
        order_type: 'DESC',
        buildings: [],
        in_plant: true,
        reg_from: 1,
        page_length: filters.page_length
    }

    const isGuard = Number(getDataUserByKey('access_profile_id')) === 3;

    const openingSelected = getUserOpening();
    const buildingSelected = getUserBuilding();

    const instanceHasBuildings = getTenantInfoByKey('is_building');
    const instanceHasOpenings = getTenantInfoByKey('is_access_opening');
    const openingSelectedInLocalStorage = openingSelected.codigo !== "";
    const buildingSelectedInLocalStorage = buildingSelected.buildingId !== "";

    const withoutOrMoreOpenings = levelSelected === OPENINGS && resources[0]?.entityCode === null;
    const withoutOrMoreBuildings = levelSelected === BUILDINGS && resources[0]?.entityCode === null;
    const withoutOrMoreAreas = levelSelected === AREAS && resources[0]?.entityCode === null;

    const instanceHas = {
        openings: instanceHasOpenings,
        buildings: instanceHasBuildings,
        areas: instanceHasBuildings
    }

    const [resTypes, setResTypes] = useState(resTypesInitial);
    const typesExample = [t('EMPS'), t('VEHS'), t('VISITS')];

    const [data, setData] = useState([]);
    const userPermissions = getDataUserByKey('permissions');
    const havePermissionToEntryOrDeparture = userPermissions.find((item) => item.access_permission_id === 1);

    const levelForWidget = getLevelsToWidgetByResources();

    const widgetName = useMemo(() => {
        return widgetNameByUserAndInfo(
            levelSelected,
            levelForWidget,
            havePermissionToEntryOrDeparture,
            openingSelected,
            buildingSelected,
            openingSelectedInTheWidget,
            buildingSelectedInTheWidget,
            resources
        );
        // eslint-disable-next-line
    }, [
        levelSelected,
        openingSelectedInTheWidget,
        buildingSelectedInTheWidget
    ]);

    const getResourcesDependingInstanceInformation = async () => {

        if (isGuard) {
            if (instanceHasOpenings && openingSelectedInLocalStorage) {

                if (instanceHasBuildings && buildingSelectedInLocalStorage) {

                    //This service searches the building's resources. If it has areas or it does not bring the resources of the searched building.
                    await getResourcesInPlaceByAreas(buildingSelected.buildingId, null, buildingSelected.buildingDescription);

                    return saveCodesIfIsguard();
                }

                await getResourcesInPlaceByOpennings(openingSelected.codigo !== '' ? openingSelected.codigo : '', '', []);
                return saveCodesIfIsguard();
            }

            if (instanceHasBuildings) {
                await getResourcesInPlaceByAreas(buildingSelected.buildingId, null, buildingSelected.buildingDescription);
                return saveCodesIfIsguard();
            }
        }

        //levels
        if (instanceHasOpenings && levelSelected === OPENINGS) return await getResourcesInPlaceByOpennings('', '', []);
        if (instanceHasBuildings && levelSelected === BUILDINGS) return await getResourcesInPlaceByBuildings(openingCodeSelectedInWidget, '', [], null, openingSelectedInTheWidget);
        if (instanceHasBuildings && levelSelected === AREAS) return await getResourcesInPlaceByAreas(buildingCodeSelectedInWidget[0], null, buildingSelectedInTheWidget);

        //only buildings
        if (!instanceHasOpenings && instanceHasBuildings) {
            if (buildingCodeSelectedInWidget.length) {
                return await getResourcesInPlaceByAreas(buildingCodeSelectedInWidget[0], null, buildingSelectedInTheWidget);
            }
            return await getResourcesInPlaceByBuildings('', '', [], null, '');
        }

        return await getResourcesInPlaceByOpennings('', '', '');
    }

    const saveCodesIfIsguard = async () => {
        await setCodesInTheResourcesInPlace({
            openingCodeSelectedInWidget: openingSelectedInLocalStorage ? openingSelected.codigo : [],
            buildingCodeSelectedInWidget: buildingSelectedInLocalStorage ? buildingSelected.buildingId : [],
            resourcesTypesSelectedInWidget: []
        });
    }

    const getDataByResourcesType = () => {
        let dataToChart = [];

        resources.forEach((el, i) => {
            if (instanceHas[levelSelected]) {

                if (havePermissionToEntryOrDeparture && isGuard) {

                    if (levelSelected === AREAS && !withoutOrMoreAreas) {
                        let total = 0;
                        total = resTypes.employeesIn && el.employeesIn ? total + el.employeesIn : total;
                        total = resTypes.vehiclesIn && el.vehiclesIn ? total + el.vehiclesIn : total;
                        total = resTypes.visitorsIn && el.visitorsIn ? total + el.visitorsIn : total;
                        dataToChart.push({ type: el.entityDescription, value: total, identifier: el.entityCode, entityHasToSearch: el.entityHasToSearch });
                    } else {
                        //resources by openings
                        dataToChart.push({ type: `${typesExample[0]}`, value: el.employeesIn, identifier: 'EMP' });
                        dataToChart.push({ type: `${typesExample[1]}`, value: el.vehiclesIn, identifier: 'VEH' });
                        dataToChart.push({ type: `${typesExample[2]}`, value: el.visitorsIn, identifier: 'VIS' });

                    }

                } else {

                    if ((!instanceHasOpenings && !instanceHasBuildings) || withoutOrMoreOpenings || withoutOrMoreBuildings || withoutOrMoreAreas) {
                        //resources in plant
                        dataToChart.push({ type: `${typesExample[0]}`, value: el.employeesIn, identifier: 'EMP' });
                        dataToChart.push({ type: `${typesExample[1]}`, value: el.vehiclesIn, identifier: 'VEH' });
                        dataToChart.push({ type: `${typesExample[2]}`, value: el.visitorsIn, identifier: 'VIS' });
                    } else {
                        let total = 0;
                        total = resTypes.employeesIn && el.employeesIn ? total + el.employeesIn : total;
                        total = resTypes.vehiclesIn && el.vehiclesIn ? total + el.vehiclesIn : total;
                        total = resTypes.visitorsIn && el.visitorsIn ? total + el.visitorsIn : total;
                        dataToChart.push({ type: el.entityDescription, value: total, identifier: el.entityCode, entityHasToSearch: el.entityHasToSearch });
                    }

                }
            } else {
                //resources in plant
                dataToChart.push({ type: `${typesExample[0]}`, value: el.employeesIn, identifier: 'EMP' });
                dataToChart.push({ type: `${typesExample[1]}`, value: el.vehiclesIn, identifier: 'VEH' });
                dataToChart.push({ type: `${typesExample[2]}`, value: el.visitorsIn, identifier: 'VIS' });
            }
        });

        setData(dataToChart);
    }

    const getResTypesSelectedToRedirect = () => {
        const resTypesSelected = [];
        const typesToFilter = {
            employeesIn: 'EMP',
            vehiclesIn: 'VEH',
            visitorsIn: 'VIS'
        };

        for (const property in resTypes) {
            if (resTypes[property]) {
                resTypesSelected.push(typesToFilter[property])
            }
        }

        setCodesInTheResourcesInPlace({
            openingCodeSelectedInWidget,
            buildingCodeSelectedInWidget,
            resourcesTypesSelectedInWidget: resTypesSelected
        });

        return resTypesSelected;
    }

    const showChartFilters = () => {
        if ((instanceHasOpenings && !withoutOrMoreOpenings) || (instanceHasBuildings && !withoutOrMoreBuildings) || (instanceHasBuildings && withoutOrMoreAreas)) {
            if (isGuard) {
                if (openingSelectedInLocalStorage) {
                    if (buildingSelectedInLocalStorage) {
                        if (withoutOrMoreAreas) {
                            return false
                        } else {
                            return true
                        }
                    }
                    return false
                }
                if (buildingSelectedInLocalStorage) {
                    if (withoutOrMoreAreas) {
                        return false
                    } else {
                        return true
                    }
                }
            } else {
                if (openingCodeSelectedInWidget.length) {
                    if (withoutOrMoreBuildings) {
                        return false
                    } else {
                        if (withoutOrMoreAreas) {
                            return false
                        }
                        return true
                    }
                }

                if (withoutOrMoreAreas) {
                    return false
                }
                return true
            }
        } else {
            return false
        }
    }

    const checkValueInAreaIdToRedirect = (entityCode, error) => {
        if (instanceHasBuildings && !withoutOrMoreBuildings && !withoutOrMoreAreas && !error) {
            if (!isGuard) {
                if (buildingCodeSelectedInWidget.length) {
                    return [entityCode];
                } else {
                    return [];
                }
            } else {
                if (buildingSelectedInLocalStorage && !withoutOrMoreAreas) {
                    return [entityCode]
                }
                return [];
            }
        } else {
            return []
        }
    }

    const redirectToReportWithFilters = async (entityCode, error) => {

        const selectMultipleOrSimpleInResourceType = showChartFilters();
        const openingCode = instanceHasOpenings ? openingCodeSelectedInWidget.length ? openingCodeSelectedInWidget : [entityCode] : [];
        const buildingId = instanceHasBuildings && !withoutOrMoreBuildings && !error ? !isGuard ? buildingCodeSelectedInWidget.length ? [Number(buildingCodeSelectedInWidget)] : [Number(entityCode)] : buildingCodeSelectedInWidget.length ? [buildingCodeSelectedInWidget] : [] : [];
        const areaId = checkValueInAreaIdToRedirect(entityCode, error);

        if (openingCode.length) await getAccessOpenings();
        if (instanceHasBuildings && buildingId.length) await getAccessBuildings(true, openingCode);
        if (instanceHasBuildings && areaId.length) await getAccessAreas(buildingId);

        setFilters({
            ...filtersInitial,
            opening_code: openingCode,
            buildings: buildingId,
            resource_type: selectMultipleOrSimpleInResourceType ? resourcesTypesSelectedInWidget : [entityCode],
            areas: areaId,
            in_plant: true,
            reg_from: 1
        });

        navigate('/reports/entryAndDeparture');
    }

    const redirectToReport = async (entity) => {
        const codes = {
            openingCodeSelectedInWidget: [],
            buildingCodeSelectedInWidget: [],
            resourcesTypesSelectedInWidget: resourcesTypesSelectedInWidget
        }

        if (isGuard && havePermissionToEntryOrDeparture) {
            return redirectToReportWithFilters(entity.identifier, false);
        }

        //change to buildings level with openings
        if (instanceHasOpenings && levelForWidget[0] === levelSelected) {
            if (instanceHasBuildings) {
                codes.openingCodeSelectedInWidget = [entity.identifier];
                const response = await getResourcesInPlaceByBuildings(entity.identifier, '', [], codes, entity.type);
                if (response === 'PARAM_ERROR') return redirectToReportWithFilters(entity.identifier, true);
                return
            }
        }

        //change to areas level with buildings
        if (instanceHasBuildings) {
            codes.openingCodeSelectedInWidget = openingCodeSelectedInWidget;
            codes.buildingCodeSelectedInWidget = [entity.identifier];

            if (entity.entityHasToSearch) {
                const response = await getResourcesInPlaceByAreas(entity.identifier, codes, entity.type);
                if (response === 'PARAM_ERROR') return redirectToReportWithFilters(entity.identifier, true);
                return
            }

        }

        return redirectToReportWithFilters(entity.identifier, false);

    }

    const goBackInfoInTheWidget = async () => {
        const codes = {
            openingCodeSelectedInWidget: [],
            buildingCodeSelectedInWidget: [],
            resourcesTypesSelectedInWidget: resourcesTypesSelectedInWidget
        }

        const previousLevel = goBackOneLevel(levelSelected, levelForWidget);

        await setLevelInTheWidget(previousLevel);
        if (previousLevel === OPENINGS) {
            await getResourcesInPlaceByOpennings('', '', []);
            setCodesInTheResourcesInPlace({
                openingCodeSelectedInWidget: [],
                buildingCodeSelectedInWidget: [],
                resourcesTypesSelectedInWidget: resourcesTypesSelectedInWidget
            })
        }

        if (previousLevel === BUILDINGS) {
            codes.openingCodeSelectedInWidget = openingCodeSelectedInWidget;
            await getResourcesInPlaceByBuildings(openingCodeSelectedInWidget, '', [], codes, openingSelectedInTheWidget);
            setCodesInTheResourcesInPlace({
                openingCodeSelectedInWidget: openingCodeSelectedInWidget,
                buildingCodeSelectedInWidget: [],
                resourcesTypesSelectedInWidget: resourcesTypesSelectedInWidget
            })
        }


    };

    const handleChangeResType = async (valueKey, value) => {

        setResTypes({
            ...resTypes,
            [valueKey]: value
        });
    }

    useEffect(() => {

        getResourcesDependingInstanceInformation();

        setResTypes(checkResTypesSelected(resourcesTypesSelectedInWidget))
        // eslint-disable-next-line
    }, [])

    useEffect(() => {

        getResTypesSelectedToRedirect();

        if (resources.length) {
            getDataByResourcesType();
        } else {
            setData([]);
        }

        // eslint-disable-next-line
    }, [resources, resTypes])

    return (
        <>
            {!isFetching && (
                <div>
                    <p className='widgetTitle'>{widgetName}</p>
                </div>
            )}

            {error.ok && error.text !== t('ERROR_TRY_AGAIN') ?

                <CustomAlert color={'danger'} text={error.text} />

                :
                <>
                    {
                        !isFetching && showChartFilters() ?
                            <div className='mb-2'>
                                <Form className='resTypeWidget'>
                                    <ButtonGroup className=''>
                                        {typesExample.map((type, i) => {
                                            return (
                                                <Button
                                                    key={i}
                                                    color=""
                                                    className={`${i === 0 ? 'btn-radius-start' : i === typesExample.length - 1 ? 'btn-radius-end' : ''} btn-outline-black`}
                                                    outline
                                                    onClick={() => handleChangeResType(keyType[i], !resTypes[keyType[i]])}
                                                    active={resTypes[keyType[i]]}
                                                >
                                                    <div className='d-flex flex-column align-items-center'>
                                                        <div className='d-flex align-items-center '>
                                                            {type}
                                                            <i className={`ms-1 fa-solid ${resTypes[keyType[i]] ? 'fa-check' : 'fa-xmark'}`}></i>
                                                        </div>
                                                    </div>
                                                </Button>
                                            )
                                        })}
                                    </ButtonGroup>
                                </Form>
                            </div>
                            : null
                    }

                    {
                        !isFetching && levelSelected !== levelForWidget[0] && levelForWidget.length > 1 && !isGuard ?
                            <div className='mt-2 ps-2'>
                                <i type='button' className="fa-solid fa-arrow-left" onClick={goBackInfoInTheWidget}></i>
                            </div>
                            : null
                    }

                    <div className=''>
                        <DonutChart
                            idChart={'legendPlace'}
                            dataChart={data}
                            widthChart={150}
                            heightChart={150}
                            withLegendProgressBar={true}
                            loadding={isFetching}
                            redirect={redirectToReport}
                        />
                    </div>
                </>
            }
        </>
    )
}
export default NumberOfResourcesByPlace